import * as StyledComponents from '../../StyledComponents';
import { OutageSideSheetDetails } from './OutageSideSheetDetails';

import styled from "styled-components";
import {
  CustomScrollbarWrapper,
} from 'cdk-radial';

/*** Link Fix */

/*
interface IAdminDataSideSheet {
  children: React.ReactNode;
  isCollapse: boolean;
  sidesheetName?: string;
}
*/

export const StyledCustomScrollbarWrapper = styled(CustomScrollbarWrapper)`
  height: calc(100% - 10px);
  overflow-x: hidden;
`;


export const OutageSideSheetBody = (): JSX.Element => {
  return (
    <StyledComponents.StyledSideSheetBodyContainer>
      <StyledCustomScrollbarWrapper>
      <OutageSideSheetDetails />
      </StyledCustomScrollbarWrapper>
    </StyledComponents.StyledSideSheetBodyContainer>
  );
};
